import { P1_LEVEL_META } from '../../telas/painel-p1/tela8-adapter';

import type { P1EscalationLevel } from '../../types';
import type React from 'react';

export interface EscalationLevelBadgeProps {
  level: P1EscalationLevel;
  current?: boolean;
}

/** Badge de nível de escalação (.escalation-level). Enums REAIS → label PT. */
export function EscalationLevelBadge({
  level,
  current = false,
}: EscalationLevelBadgeProps): React.JSX.Element | null {
  const m = P1_LEVEL_META[level];
  if (m === undefined) return null;
  return (
    <span
      className={`escalation-level escalation-level--${m.tone}${
        current ? ' escalation-level--current' : ''
      }`}
    >
      {m.label}
      {current ? ' · atual' : ''}
    </span>
  );
}
